import { RegistrationError } from '../components/registration-error'

export const RegistrationNotFoundPage = () => (
  <RegistrationError
    titleKey='login.registration.notFoundTitle'
    descriptionKey='login.registration.notFoundDescription'
    pageTitleKey='login.registration.notFoundPageTitle'
  />
)
